module.exports = __webpack_public_path__ + "media/images/reviews/circle_review_avatar_2-4c08e78cef019a267d9cc839e7453b6d.png";